import React from 'react'
import './stylesheets/footer.css'
import { NavLink } from 'react-router-dom'
import logoimg from './digiwork-logo.png'

function Footer() {
    return (

        <footer className="bd-footer py-4 py-md-5 mt-5 bg-body-tertiary">
            <div className="container py-4 py-md-5 px-4 px-md-3 text-body-secondary">
                <div className="row">
                    <div className="col-lg-3 mb-3">
                        <img src={logoimg}/>
                        <ul className="list-unstyled small">
                            <li className="mb-2">Designed and built with all the love in the world by the <a href="/docs/5.3/about/team/">
                                digiWork team</a> with the help of <a href="https://github.com/twbs/bootstrap/graphs/contributors">our contributors</a>.</li>
                            <li className="mb-2">
                                email 
                                <a href="https://github.com/twbs/bootstrap/blob/main/LICENSE" target="_blank" rel="license noopener"> email@me.com</a><br/>
                                contact <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank" rel="license noopener">01234567890</a></li>
                            <li className="mb-2">#10, street 39, area 7, block 44 district xyz, city abc</li>
                        </ul>
                    </div>
                    <div className="col-6 col-lg-2 offset-lg-1 mb-3">
                        <h5>Links</h5>
                        <p><NavLink className="headernavlinks" to="/">Home</NavLink></p>
                        <p><NavLink className="headernavlinks" to="/about">About</NavLink></p>
                        <p><NavLink className="headernavlinks" to="/services">Services</NavLink></p>
                        <p><NavLink className="headernavlinks" to="/become a seller">Become a seller</NavLink></p>
                        <p><NavLink className="headernavlinks" to="/sellers">Sellers</NavLink></p>
                        <p><NavLink className="headernavlinks" to="/tutorials">Tutorials</NavLink></p>
                    </div>
                    <div className="col-6 col-lg-2 mb-3">
                        <h5>fields</h5>
                        <p><NavLink className="links" to="/art">art</NavLink></p>
                        <p><NavLink className="links" to="/business">business</NavLink></p>
                        <p><NavLink className="links" to="/coaching">coaching</NavLink></p>
                        <p><NavLink className="links" to="/design">design</NavLink></p>
                        <p><NavLink className="links" to="/ecommerce">ecommerce</NavLink></p>
                        <p><NavLink className="links" to="/finance">finance</NavLink></p>
                        <p><NavLink className="links" to="/gamedev">gamedev</NavLink></p>
                        <p><NavLink className="links" to="/html">html</NavLink></p>
                        <p><NavLink className="links" to="/ios">ios</NavLink></p>
                        <p><NavLink className="links" to="/javascript">javascript</NavLink></p>
                    </div>
                    <div className="col-6 col-lg-2 mb-3">
                        <h5>departments</h5>
                        <p><NavLink className="links" to="/design">design</NavLink></p>
                        <p><NavLink className="links" to="/ecommerce">ecommerce</NavLink></p>
                        <p><NavLink className="links" to="/finance">finance</NavLink></p>
                        <p><NavLink className="links" to="/gamedev">gamedev</NavLink></p>
                    </div>
                    <div className="col-6 col-lg-2 mb-3">
                        <h5>Community</h5>
                        <p><NavLink className="headernavlinks" to="/become a seller">Become a seller</NavLink></p>
                        <p><NavLink className="headernavlinks" to="/sellers">Sellers</NavLink></p>
                        <p><NavLink className="headernavlinks" to="/tutorials">Tutorials</NavLink></p>
                    </div>
                </div>
            </div>
        </footer>

    )
}

export default Footer